import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const PatientKulawruttaForm = (props) => {
  const navigate = useNavigate();
  const { initialValues, onSubmit } = props;

const patientKulawruttaInfo = props.initialValues.patientKulawrutta?.[0] || {};


  // Define the form's initial values
  const formInitialValues = {
    PATIENT_KULAWRUTTA: patientKulawruttaInfo?.PATIENT_KULAWRUTTA || "",
  };

  // Define the validation schema
  const validationSchema = Yup.object().shape({
    PATIENT_KULAWRUTTA: Yup.string(),
  });

  return (
    <div className="form-wrapper">
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values); // Pass form values to the parent component's onSubmit function
          setSubmitting(false);
        }}
      >
        <Form>
          <FormGroup>
            <label htmlFor="PATIENT_KULAWRUTTA">Kulawrutta</label>
            <Field name="PATIENT_KULAWRUTTA" as="textarea" className="form-control" />
            <ErrorMessage name="PATIENT_KULAWRUTTA" component="div" className="invalid-feedback" />
          </FormGroup>

          <div className="form-buttons">
            <button type="button" className="btn-back" onClick={() => navigate(-1)}>Back</button>
            <button type="submit" className="btn-next">Next</button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default PatientKulawruttaForm;
